<template>
  <div>
    <div class="mb-3">
      <div>
        <label class="ts-text-xs required">{{
          $t('setupOurFarmers.employeeName')
        }}</label>
        <Select
          v-model.trim="model.employee_id"
          :placeholder="$t('setupOurFarmers.employeeName')"
          :filterable="true"
          :clearable="true"
          :class="{ 'ivu-form-item-error': errors.has('employee_id') }"
        >
          <Option
            v-for="(employee, index) in employee"
            :key="index"
            :value="employee.employee_id"
            >{{ employee.employee_name_en }}
          </Option>
        </Select>
        <div class="validate ts-text-xs" v-if="errors.has('employee_id')">
          {{ errors.first('employee_id') }}
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div>
        <label class="ts-text-xs">{{ $t('setupOurFarmers.facebook') }}</label>
        <input
          v-model.trim="model.facebook_url"
          :placeholder="$t('setupOurFarmers.facebookUrl')"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('facebook_url') }"
        />
      </div>
      <div class="invalid-feedback" v-if="errors.has('facebook_url')">
        {{ errors.first('facebook_url') }}
      </div>
    </div>
    <div class="mb-3">
      <div>
        <label class="ts-text-xs">{{ $t('setupOurFarmers.telegram') }}</label>
        <input
          v-model.trim="model.telegram_url"
          :placeholder="$t('setupOurFarmers.telegramUrl')"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('telegram_url') }"
        />
      </div>
      <div class="invalid-feedback" v-if="errors.has('telegram_url')">
        {{ errors.first('telegram_url') }}
      </div>
    </div>
    <div class="mb-3">
      <div>
        <label class="ts-text-xs">{{ $t('setupOurFarmers.linkedin') }}</label>
        <input
          v-model.trim="model.linkedin_url"
          :placeholder="$t('setupOurFarmers.linkedinUrl')"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('linkedin_url') }"
        />
      </div>
      <div class="invalid-feedback" v-if="errors.has('linkedin_url')">
        {{ errors.first('linkedin_url') }}
      </div>
    </div>
    <div slot="footer">
      <div class="ts-flex ts-justify-end ts-space-x-2 ts-sh">
        <ts-button @click.prevent="() => $emit('cancel')" class="btn-gray">{{
          $t('cancel')
        }}</ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          outline
          :waiting="waiting_new"
          :disabled="waiting || waiting_new"
          @click.prevent="onSaveAddNew"
          >{{ $t('save_add_new') }}
        </ts-button>

        <ts-button
          color="primary"
          v-if="!isUpdate"
          :waiting="waiting"
          :disabled="waiting || waiting_new"
          @click.prevent="onSave"
          >{{ $t('save') }}
        </ts-button>

        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}
        </ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { isEmpty } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'farmers-form',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      model: {
        employee_id: null,
        facebook_url: null,
        telegram_url: null,
        linkedin_url: null
      }
    }
  },
  computed: {
    ...mapState('website/setupOurFarmers', ['edit_data', 'employee']),
    isUpdate() {
      return !isEmpty(this.edit_data)
    }
  },
  created() {
    this.setEditData()
  },

  methods: {
    ...mapActions('website/setupOurFarmers', ['getEmployee']),
    async fetchResource() {
      this.loading = true
      await this.getEmployee()
      this.loading = false
    },

    async onSaveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('website/setupOurFarmers/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.$emit('fetchData')
          this.clearInput()
          this.waiting_new = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    async onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('website/setupOurFarmers/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('website/setupOurFarmers/update', {
          id: this.edit_data.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      this.fetchResource()
      if (!isEmpty(this.edit_data)) {
        this.model.employee_id = this.edit_data.employee_id
        this.model.facebook_url = this.edit_data.facebook_url
        this.model.telegram_url = this.edit_data.telegram_url
        this.model.linkedin_url = this.edit_data.linkedin_url
      }
    },
    clearInput() {
      this.errors = new Errors()
      this.model.employee_id = null
      this.model.facebook_url = null
      this.model.telegram_url = null
      this.model.linkedin_url = null
    }
  }
}
</script>
